import { faCheckCircle, faCircleXmark, faClock, faFileCheck, faFileSlash, faPencil, faShare } from '@fortawesome/pro-light-svg-icons'
import { DisplayStatus } from '../../../../../../baseComponents/Displays/DisplayStatus'
import useTwinTranslation from '../../../../../../utils/hooks/useTwinTranslation'
import { sellOrderStatusInversed } from '@teinor/erp/types/company/order/sell/sellOrder'
import { sellDeliveryNoteStatusInversed } from '@teinor/erp/types/company/order/sell/sellDeliveryNote'
import { sellInvoiceStatusInversed } from '@teinor/erp/types/company/order/sell/sellInvoice'
import { QuoteOrderStatusInversed } from '@teinor/erp/types/company/order/quote/quoteOrder'
import { workSheetStatusInversed } from '@teinor/erp/types/company/order/sell/workSheet'

interface RenderQuoteStatusProps {
    value: string
}

export const RenderQuoteStatus: React.FC<RenderQuoteStatusProps> = ({ value }) => {
    const parsedValue = parseInt(value)
    const { t } = useTwinTranslation()

    if (parsedValue === QuoteOrderStatusInversed['creating']) {
        return <DisplayStatus icon={faPencil} colorText='text-gray-97' text={t('draft', 'Borrador')} />
    } else if (parsedValue === QuoteOrderStatusInversed['waitingResponse']) {
        return <DisplayStatus icon={faClock} colorText='text-orange-DE' text={t('pending', 'En espera')} />
    } else if (parsedValue === QuoteOrderStatusInversed['denied']) {
        return <DisplayStatus icon={faFileSlash} colorText='text-red-BA' text={t('cancelled', 'Cancelado')} />
    } else if (parsedValue === QuoteOrderStatusInversed['sent']) {
        return <DisplayStatus icon={faShare} colorText='text-purple-86' text={t('sent', 'Enviado')} />
    } else if (parsedValue === QuoteOrderStatusInversed['processed']) {
        return <DisplayStatus icon={faFileCheck} colorText='text-green-43' text={t('processed', 'Procesado')} />
    }
    return <DisplayStatus icon={faCheckCircle} colorText='text-green-43' text={t('accepted', 'Aceptado')} />
}

interface RenderOrderStatusWithPendingUnitsProps extends RenderQuoteStatusProps { }

export const RenderSellOrderStatus: React.FC<RenderOrderStatusWithPendingUnitsProps> = ({ value }) => {
    const parsedValue = parseInt(value)
    const { t } = useTwinTranslation()
    if (parsedValue === sellOrderStatusInversed['creating']) {
        return <DisplayStatus icon={faPencil} colorText='text-gray-97' text={t('draft', 'Borrador')} />
    } else if (parsedValue === sellOrderStatusInversed['waitingResponse']) {
        return <DisplayStatus icon={faClock} colorText='text-orange-DE' text={t('preparing', 'Preparando')} />
    } else if (parsedValue === sellOrderStatusInversed['denied']) {
        return <DisplayStatus icon={faFileSlash} colorText='text-red-BA' text={t('cancelled', 'Cancelado')} />
    }
    return <DisplayStatus icon={faCheckCircle} colorText='text-green-43' text={t('finished', 'Finalizado')} />
    
}

interface RenderSellDeliveryNoteStatusProps extends RenderQuoteStatusProps { }

export const RenderSellDeliveryNoteStatus: React.FC<RenderSellDeliveryNoteStatusProps> = ({ value }) => {
    const parsedValue = parseInt(value)
    const { t } = useTwinTranslation()
    if (parsedValue === sellDeliveryNoteStatusInversed['creating']) {
        return <DisplayStatus icon={faPencil} colorText='text-gray-97' text={t('draft', 'Borrador')} />
    } else if (parsedValue === sellDeliveryNoteStatusInversed['accepted']) {
        return <DisplayStatus icon={faCheckCircle} colorText='text-green-43' text={t('finished', 'Finalizado')} />
    } else if (parsedValue === sellDeliveryNoteStatusInversed['refunded']) {
        return <DisplayStatus icon={faCircleXmark} colorText='text-red-BA' text={t('refundedF', 'Devuelta')} />
    }
    return <DisplayStatus icon={faClock} colorText='text-orange-DE' text={t('pendingInvoicedShort', 'Pte. Fact.')} />
}

interface RenderSellInvoiceStatusProps extends RenderQuoteStatusProps { }

export const RenderSellInvoiceStatus: React.FC<RenderSellInvoiceStatusProps> = ({ value }) => {
    const parsedValue = parseInt(value)
    const { t } = useTwinTranslation()
    if (parsedValue === sellInvoiceStatusInversed['creating']) {
        return <DisplayStatus icon={faPencil} colorText='text-gray-97' text={t('draft', 'Borrador')} />
    } else if (parsedValue === sellInvoiceStatusInversed['refunded']) {
        return <DisplayStatus icon={faCircleXmark} colorText='text-red-BA' text={t('refundedF', 'Devuelta')} />
    }
    return <DisplayStatus icon={faCheckCircle} colorText='text-green-43' text={t('invoiced', 'Facturado')} />
}
interface RenderSellInvoiceRefundStatusProps extends RenderQuoteStatusProps { }

export const RenderOrderRefundStatus: React.FC<RenderSellInvoiceRefundStatusProps> = ({ value }) => {
    const { t } = useTwinTranslation()
    return <DisplayStatus icon={faCheckCircle} colorText='text-green-43' text={t('refunded', 'Devuelto')} />
}

interface RenderWorkSheetStatusProps extends RenderQuoteStatusProps { }

export const RenderWorkSheetStatus: React.FC<RenderWorkSheetStatusProps> = ({ value }) => {
    const parsedValue = parseInt(value)
    const { t } = useTwinTranslation()
    if (parsedValue === workSheetStatusInversed['working']) {
        return <DisplayStatus icon={faPencil} colorText='text-gray-97' text={t('working', 'Trabajando')} />
    }
    return <DisplayStatus icon={faCheckCircle} colorText='text-green-43' text={t('finished', 'Finalizado')} />
}
